// removed by extract-text-webpack-plugin
module.exports = {"header":"app-pages-Library-SalesType-SalesTypeDetail-NoGratuityModal-__NoGratuityModal___3gN5Z","dialog":"app-pages-Library-SalesType-SalesTypeDetail-NoGratuityModal-__NoGratuityModal___2UR6x","no-button":"app-pages-Library-SalesType-SalesTypeDetail-NoGratuityModal-__NoGratuityModal___3YJtJ","yes-button":"app-pages-Library-SalesType-SalesTypeDetail-NoGratuityModal-__NoGratuityModal___1K7yK"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/SalesType/SalesTypeDetail/NoGratuityModal/NoGratuityModal.css
// module id = 2458
// module chunks = 0